"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const status_and_notifications_1 = require("../../../../hsbc_img/status_and_notifications");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const walletQuery_1 = require("../../../../queries/walletQuery");
const Root_1 = require("../../../../router/Root");
const translationUtil_1 = require("../../../../utils/translationUtil");
const zustandStore_1 = require("../../../../zustandStore");
const footer_1 = __importDefault(require("../../../organisms/footer"));
const virtualCard_1 = require("../../request/virtualCard");
const requestInfoAside_1 = __importDefault(require("../asides/requestInfoAside"));
const walletDetails_1 = require("../component/walletDetails");
const cardUtils_1 = require("../myCardsListView/cardUtils");
const settlementsContent_1 = __importDefault(require("./settlementsContent"));
const walletCard_1 = __importDefault(require("./walletCard"));
const walletDetailsContainer_1 = __importDefault(require("./walletDetailsContainer"));
const cardProviderStyles = {
    fontSize: '12px',
    fontWeight: 500,
    color: '#000000',
};
const getVirtualCardTypeLabel = ({ card, fields }) => {
    const cardTypeLabel = appConstants_1.virtualCardTypes.find(({ cardsKey }) => cardsKey === card?.cardType)?.label;
    if (card?.cardType === 'RECURRING_USE') {
        // Just in case there is no default frequency state to key into we add it here
        const frequency = card.frequency || fields.frequency;
        const frequencyLabel = frequency ? frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase() : '';
        return frequencyLabel + ' ' + cardTypeLabel;
    }
    else {
        return cardTypeLabel || 'Not available';
    }
};
const lexico = new lexico_1.default();
const WalletDetailsPage = () => {
    const { virtualCardId, taskId } = (0, react_router_1.useParams)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { setDialog, setFooterButtons, setNotification, setWalletDetails, wallet } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { walletDetails } = wallet;
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const query = virtualCardId ? (0, walletQuery_1.virtualCardTask)(virtualCardId || '') : (0, walletQuery_1.walletDetailsQuery)(taskId || '');
    const { data: walletData } = (0, react_query_1.useQuery)(query);
    const isCardOwner = walletData?.context?.request?.requester?.userId === userData?.userId;
    const { data: vCard } = (0, react_query_1.useQuery)((0, paymentQuery_1.virtualCardDataQuery)(walletData?.subjectId, isCardOwner));
    const [purchaseRequest, setPurchaseRequest] = (0, react_1.useState)({});
    const [openRequestInfoAside, setOpenRequestInfoAside] = (0, react_1.useState)(false);
    const theme = (0, material_1.useTheme)();
    const virtualCard = (0, virtualCard_1.getVirtualCard)(vCard);
    const initialCardStatus = virtualCard?.cardStatus || virtualCard?.status;
    const cardStatus = initialCardStatus?.replace('_', ' ');
    const [task, setTask] = (0, react_1.useState)({});
    const fields = walletData?.context?.request?.fields;
    const walletInfo = {
        balance: virtualCard?.balance,
        amount: walletData?.request?.amount,
        authPaddingPercentage: walletData?.request?.authPaddingPercentage,
    };
    const { address, zipCode, city, addressCode } = (0, cardUtils_1.getCardAddressData)(virtualCard);
    const cancelVirtucalCardQuery = (0, walletQuery_1.useCancelVirtualCardMutationQuery)();
    const remainingValue = (0, cardUtils_1.getRemainingValue)(walletInfo);
    const spentAmount = (0, cardUtils_1.getSpentAmount)(walletInfo);
    const spentPercentage = (0, cardUtils_1.getSpentPercentage)(walletInfo);
    const { data: cardAmount } = (0, react_query_1.useQuery)((0, paymentQuery_1.currencyAndTotalQuery)(walletData?.request?.currency || '', walletData?.request?.amount || 0));
    const { data: remainingCardValue } = (0, react_query_1.useQuery)((0, paymentQuery_1.currencyAndTotalQuery)(walletData?.request?.currency || '', virtualCard?.status === 'IN_PROGRESS' ? Number(walletData?.request?.amount) : remainingValue || 0));
    const { data: spentCardValue } = (0, react_query_1.useQuery)((0, paymentQuery_1.currencyAndTotalQuery)(walletData?.request?.currency || '', virtualCard?.status === 'IN_PROGRESS' ? 0 : spentAmount || 0));
    const onClose = () => {
        setOpenRequestInfoAside(false);
    };
    const label1 = `${globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? strings_1.walletStrings.VIRTUAL_CARD_CAN_BE_USED_UNTIL
        : strings_1.walletStrings.VIRTUAL_CARD_END_DATE}
`;
    const value1 = (0, virtualCard_1.getCardValidEndingOnDate)(task.card?.validEndingOn);
    const label2 = 'Card Type';
    const value2 = getVirtualCardTypeLabel({ card: virtualCard, fields });
    const label3 = 'Card Status';
    let value3 = cardStatus ? cardStatus?.charAt(0) + cardStatus?.slice(1).toLowerCase() : 'Not available';
    value3 = value3.toLowerCase() === 'canceled' ? (0, translationUtil_1.getCancelledWord)(value3) : value3;
    const label4 = 'Billing Address';
    const value4 = address ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: address }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", children: [city, " ", addressCode, " ", zipCode] })] })) : ('Not available');
    const label5 = fields?.frequency && 'Subscription Frequency';
    const value5 = fields?.frequency && appConstants_1.subscriptionFrequencies.find(f => f.key === fields.frequency)?.label;
    const label6 = fields?.ends && 'Subscription Ends';
    const value6 = fields?.ends && appConstants_1.subscriptionEndings.find(f => f.key === fields.ends)?.label;
    const label7 = fields?.numberOfPayments && 'Number of Payments';
    const value7 = fields?.numberOfPayments;
    (0, react_use_1.useShallowCompareEffect)(() => {
        if (virtualCard && walletData) {
            setTask({
                ...walletData,
                card: {
                    ...walletData.card,
                    ...virtualCard,
                },
            });
        }
    }, [virtualCard, walletData]);
    (0, react_1.useEffect)(() => {
        if (!walletData || !walletData?.context?.request?.fields) {
            return;
        }
        const fields = lodash_1.default.get(walletData, 'context.request.fields');
        setPurchaseRequest(walletData?.request && {
            ...walletData,
            request: {
                ...walletData?.request,
                profileId: lodash_1.default.get(walletData, 'context.request.profileId', 'default'),
                fields: fields || {
                    amount: walletData?.context.request.fields.amount,
                    comments: walletData?.context.request.fields.comments,
                    description: walletData?.request.title,
                    endDate: walletData?.context.request.fields.endDate,
                },
                coding: walletData?.context.request.coding,
            },
        });
        setWalletDetails(walletData);
    }, [walletData]);
    (0, react_1.useEffect)(() => {
        setFooterButtons([
            {
                id: 'cancelCard',
                disabled: !task?.card?.status || task?.card?.status !== 'ACTIVE',
                dataTestId: 'cancel-card-btn',
                label: strings_1.walletStrings.CANCEL_CARD_BUTTON,
                color: uiConstants_1.UI_BUTTON_SECONDARY,
                onclick: () => openConfirmCancelCardAside(),
            },
            {
                id: 'viewRequest',
                dataTestId: 'view-request-btn',
                label: strings_1.walletStrings.VIEW_REQUEST,
                color: uiConstants_1.UI_BUTTON_PRIMARY,
                onclick: () => setOpenRequestInfoAside(true),
            },
        ]);
    }, [walletDetails, task?.card]);
    const handleCancelRequest = () => {
        cancelVirtucalCardQuery.mutate({
            teamId: walletData?.request?.teamId,
            userId: userData.userId,
            isCardOwner: walletData?.context.request.requester.userId === userData.userId,
            subjectId: walletData?.subjectId,
            virtualCardId: walletData?.request?.virtualCardId,
        }, {
            onSuccess: () => {
                setWalletDetails({
                    ...walletDetails,
                    card: {
                        ...walletDetails.card,
                        status: 'EXPIRED',
                    },
                });
                setTask(prevState => ({
                    ...prevState,
                    card: {
                        ...prevState.card,
                        status: 'EXPIRED',
                    },
                }));
            },
            onSettled: async () => {
                if (taskId) {
                    await Root_1.queryClient.invalidateQueries({
                        queryKey: walletQuery_1.walletKeys.getWalletDetails(taskId),
                    });
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: paymentQuery_1.paymentKeys.getVirtualCardData(walletData?.subjectId, isCardOwner),
                    });
                }
                if (virtualCardId) {
                    await Root_1.queryClient.invalidateQueries({
                        queryKey: walletQuery_1.walletKeys.getVirtualCardtask(virtualCardId),
                    });
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: paymentQuery_1.paymentKeys.getVirtualCardData(walletData?.subjectId, isCardOwner),
                    });
                }
            },
        });
    };
    const openConfirmCancelCardAside = () => {
        if (!walletData?.subjectId || !walletData?.request?.virtualCardId) {
            return;
        }
        if (task?.card?.status !== 'ACTIVE') {
            setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: strings_1.walletStrings.CANCEL_CARD_ERROR,
                },
            ]);
            return;
        }
        setDialog({
            message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? strings_1.walletStrings.HSBC_CANCEL_CARD_MESSAGE_TEXT
                : strings_1.walletStrings.CANCEL_CARD_MESSAGE_TEXT,
            type: strings_1.notificationStrings.WARNING,
            open: true,
            actionText: 'YES, Cancel Card',
            showCancel: true,
            onAccept: () => handleCancelRequest(),
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(walletDetailsContainer_1.default, { children: [(0, jsx_runtime_1.jsxs)(walletDetails_1.WalletDetailsWrappper, { "data-testid": "wallet-details-wrapper", children: [(0, jsx_runtime_1.jsx)(walletCard_1.default, { task: task, children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { style: {
                                        marginLeft: '-17px',
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        textTransform: 'none',
                                        paddingTop: '20px',
                                        top: '10px',
                                        position: 'relative',
                                    }, children: "Use these card details to make the purchase" })) : null }, task.id), (0, jsx_runtime_1.jsxs)(walletDetails_1.CardDetails, { "data-testid": "card-details", children: [(0, jsx_runtime_1.jsxs)(walletDetails_1.SpendDetails, { "data-testid": "spend-details", children: [(0, jsx_runtime_1.jsxs)(walletDetails_1.DetailItem, { children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { children: "Total" }), (0, jsx_runtime_1.jsx)(walletDetails_1.TypographyValue, { children: cardAmount })] }), (0, jsx_runtime_1.jsx)(walletDetails_1.DetailItem, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { children: "Spent" }), (0, jsx_runtime_1.jsx)(walletDetails_1.TypographyValue, { component: "div", color: spentAmount && spentAmount > 0 ? 'red' : '', children: spentCardValue })] }) }), (0, jsx_runtime_1.jsxs)(walletDetails_1.DetailItem, { children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { children: "Remaining" }), (0, jsx_runtime_1.jsx)(walletDetails_1.TypographyValue, { color: (remainingValue ?? 0) <= 0
                                                            ? theme.palette.tsGoColor.red
                                                            : globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                                                ? theme.palette.hsbcColor.green
                                                                : theme.palette.tsGoColor.green, children: remainingCardValue })] })] }), (0, jsx_runtime_1.jsx)(material_1.Box, { className: "progress-bar", children: (0, jsx_runtime_1.jsx)(material_1.LinearProgress, { color: spentPercentage >= 100 ? 'error' : 'success', style: {
                                                ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                                    ? {
                                                        color: spentPercentage >= 100 ? 'red' : 'hsla(178, 100%, 26%, 1)',
                                                    }
                                                    : {}),
                                            }, variant: "determinate", value: spentPercentage, sx: [
                                                {
                                                    height: theme.tsGoUnit.tsUnitHalf,
                                                },
                                                spentPercentage === 0
                                                    ? {
                                                        backgroundColor: theme.palette.tsGoColor.gray,
                                                    }
                                                    : {
                                                        backgroundColor: '',
                                                    },
                                            ] }) }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { display: 'flex', marginRight: theme.tsGoUnit.tsUnitHalf, marginTop: theme.tsGoUnit.tsUnit }, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, spacing: 2, sx: { width: '100%' }, children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, { size: {
                                                        xs: 12,
                                                        sm: 4,
                                                    }, children: [label1 && value1 && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { paddingTop: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsxs)(walletDetails_1.TypographyLabel, { style: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? cardProviderStyles : {}, children: [label1, ' ', globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' ', (0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusInformationOnLight, { "data-testid": "InfoIcon", style: { width: '12px', height: '12px' } })] })) : null] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: value1 })] })), label2 && value2 && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { paddingTop: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { style: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? cardProviderStyles : {}, children: label2 }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: value2 })] })), label3 && value3 && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { paddingTop: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { style: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? cardProviderStyles : {}, children: label3 }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: value3 })] }))] }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { size: {
                                                        xs: 12,
                                                        sm: 4,
                                                    }, children: [label4 && value4 && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { paddingTop: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { style: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? cardProviderStyles : {}, children: label4 }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: value4 })] })), label5 && value5 && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { paddingTop: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { style: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? cardProviderStyles : {}, children: label5 }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: value5 })] })), label6 && value6 && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { paddingTop: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { style: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? cardProviderStyles : {}, children: label6 }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: value6 })] }))] }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: {
                                                        xs: 12,
                                                        sm: 4,
                                                    }, children: label7 && value7 && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { paddingTop: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(walletDetails_1.TypographyLabel, { style: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? cardProviderStyles : {}, children: label7 }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", children: value7 })] })) })] }) })] })] }), (0, jsx_runtime_1.jsx)(settlementsContent_1.default, {})] }), (0, jsx_runtime_1.jsx)(footer_1.default, {}), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(requestInfoAside_1.default, { asideTitle: lexico.trc('aside title', 'Request info'), openAside: openRequestInfoAside, request: purchaseRequest?.request, onClose: onClose }) })] }));
};
exports.default = WalletDetailsPage;
